export const GET_DASHBOARD_STATS_REQUEST = 'GET_DASHBOARD_STATS_REQUEST';
export const GET_DASHBOARD_STATS_SUCCESS = 'GET_DASHBOARD_STATS_SUCCESS';
export const GET_DASHBOARD_STATS_FAILURE = 'GET_DASHBOARD_STATS_FAILURE';

export const GET_MONTHLY_SCAN_STATS_REQUEST = 'GET_MONTHLY_SCAN_STATS_REQUEST';
export const GET_MONTHLY_SCAN_STATS_SUCCESS = 'GET_MONTHLY_SCAN_STATS_SUCCESS';
export const GET_MONTHLY_SCAN_STATS_FAILURE = 'GET_MONTHLY_SCAN_STATS_FAILURE';

export const GET_LICENSE_USAGE_REQUEST = 'GET_LICENSE_USAGE_REQUEST';
export const GET_LICENSE_USAGE_SUCCESS = 'GET_LICENSE_USAGE_SUCCESS';
export const GET_LICENSE_USAGE_FAILURE = 'GET_LICENSE_USAGE_FAILURE';